import {
  Button,
  CircularProgress,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { handleReportConetnt } from "../../../redux/guest-slices/common.slice";
import { hideDialog } from "../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../../hooks/useToast";
import InputField1 from "../../ui/InputField1";
import Icons from "../../../assets/js/Icons";
import moment from "moment";
import { COMMENT_REPORT, FORUM_REPORT } from "../../../utils/keywords";

function Report() {
  const toast = useToast();
  const dispatch = useDispatch();
  const { data, loadings, type } = useSelector((state) => state.otherSlice);
  const { member, specialist } = useSelector((state) => state.authSlice);
  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog());
  };

  // Handle report coment
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    if (
      Object.values(formData)?.some((value) => value?.trim() === "" || !value)
    ) {
      return toast.error("Please fill all required field!");
    }
    const response = await dispatch(handleReportConetnt(formData));
    if (handleReportConetnt.fulfilled.match(response)) {
      toast.success(response?.payload?.message || "Content reported successfully!");
      setTimeout(() => {
        handleClose();
      }, 500);
    }
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          Report
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "black",
            position: "absolute",
            bgcolor: "#0000001f !important",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <Stack spacing={2} component="form" onSubmit={handleSubmit}>
          <InputField1 name="title" placeholder="Enter Report Title" />

          <InputField1
            name="content"
            type="textarea"
            defaultValue={
              type === COMMENT_REPORT
                ? `Hi,\n\nI am ${member?.fullName?.toUpperCase()}. This is the report for the comment which Dr. ${data?.user?.fullName?.toUpperCase()} left on ${moment(
                  data?.createdAt
                ).format("DD-MMM-YYYY")}.`
                : type === FORUM_REPORT
                  ? `Hi,\n\nI am ${member?.fullName?.toUpperCase() ||
                  specialist?.fullName?.toUpperCase()
                  }. This is the report for the forum which Dr. ${data?.user?.fullName?.toUpperCase()} left on ${moment(
                    data?.createdAt
                  ).format("DD-MMM-YYYY")}.`
                  : null
            }
          />

          <Button
            type="submit"
            color="primary"
            variant="contained"
            sx={{
              width: "100%",
              justifyContent: "center",
            }}
            endIcon={
              loadings?.craete && (
                <CircularProgress size={22} color="text" thickness={6} />
              )
            }
          >
            Submit
          </Button>
        </Stack>
      </DialogContent>
    </Paper>
  );
}

export default Report;
